export * from '@primeuix/themes/nora/inputotp';
export { default } from '@primeuix/themes/nora/inputotp';
